import Vue from 'vue'
import Vuex from 'vuex'
import database from '@/main_images_data'


Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		database: database.database,
		current_item: null,
		next_item: null,
		previous_item: null,
	},
	mutations: {
		current_item(state, new_current_item) {
			state.current_item = new_current_item
		},
		previous_item(state, new_current_item) {
			state.previous_item = new_current_item
		},
		next_item(state, new_current_item) {
			state.next_item = new_current_item
		}
	},
	actions: {
		set_current_item({commit, getters}, new_url) {
			const newCu = getters.itemByUrl(new_url);
			commit('current_item', newCu)
			const id = newCu.id_num;
			const db = getters.allItems
			const next_id = (id + 1) % db.length
			const prev_id = ((id - 1) + db.length) % db.length
			commit("previous_item", db[prev_id])
			commit("next_item", db[next_id])
		}
	},
	getters: {
		allItems: state => {
			return state.database
		},
		itemByUrl: state => url => {
			return state.database.find(x => x.url_title == url)
		},
		current_item: state => {
			return state.current_item
		},
		previous_item: state => {
			return state.previous_item
		},
		next_item: state => {
			return state.next_item
		}
	},
	modules: {
	}
})
